import styled from 'styled-components';

export const ModalTitle = styled.div(
  ({
    theme: {
      colors, fonts, indents, modal,
    },
  }) => ({
    ...fonts[modal.TITLE_FONT],
    marginBottom: indents.INDENT_2,
    paddingTop: indents.INDENT_2,
    paddingLeft: indents.INDENT_2,
    paddingRight: indents.INDENT_2,
    color: colors.TEXT_PRIMARY,
  }),
);
